









































// Importing Alert List Component
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing input field
import BaseInputField from '@/ui/BaseInputField.vue';
// A specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';

export default {
    name: 'TheFormCoupons',
    components: {
        BaseAlertList,
        BaseInputField,
    },
    props: {
        coupon: Object,
        errors: Array,
    },
    data() {
        return {};
    },
    methods: {},
};
